<template>
  <div class="data-team">
    <div class="operate-list" v-if="hasPermission">
      <base-button
        v-if="has_TL_privilege"
        class="operate-item pointer"
        @click="$refs.updateOwnerDialog.open()"
        type="text"
      >
        更换负责人
      </base-button>
      <base-button
        v-if="has_TM_privilege"
        class="operate-item pointer"
        @click="$refs.addNewParticipantDialog.open()"
        type="text"
      >
        添加参与人
      </base-button>
    </div>
    <el-table
      border
      :data="teamMembers"
      class="table-team"
      :header-cell-style="{ background: 'rgba(245, 247, 250, 1)', color: '#606266' }"
    >
      <el-table-column prop="name" label="人员/角色" align="center">
        <template v-slot="scope">
          <div class="name-cell">
            <staff-popover :staffId="scope.row.id" v-if="scope.row.type == 'user'">
              <template v-slot:reference>
                <el-tooltip
                  :content="scope.row.name || '无'"
                  placement="top"
                  :disabled="!scope.row.id || scope.row.id.length > 3"
                >
                  <staff-avatar :size="30" class="avatar" :user="scope.row"></staff-avatar>
                </el-tooltip>
              </template>
            </staff-popover>
            <el-tooltip v-if="scope.row.tip" :content="scope.row.tip" placement="top">
              <div style="margin-left: 8px">{{ scope.row.name }}</div>
            </el-tooltip>
            <div v-else style="margin-left: 8px">{{ scope.row.name }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="role" label="成员角色" align="center"></el-table-column>
      <el-table-column v-if="hasPermission" label="操作" align="center">
        <template v-slot="scope">
          <el-button
            v-if="has_TM_privilege && scope.row.role !== '负责人'"
            @click="removeMembers(scope.row)"
            type="text"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--添加参与人-->
    <add-new-participant-dialog
      ref="addNewParticipantDialog"
      :roles="roles"
      @select="addParticipant"
      :project-id="taskInfo.projectId"
    ></add-new-participant-dialog>
    <!--更换负责人-->
    <update-owner-dialog
      ref="updateOwnerDialog"
      :project-id="taskInfo.projectId"
      @select="updateOwner"
    ></update-owner-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import AddNewParticipantDialog from "@/components/Task/TeamDialog/AddNewParticipantDialog"
import UpdateOwnerDialog from "@/components/Task/TeamDialog/UpdateOwnerDialog"
import { updateParticipants, updateOwner } from "@/api/project/task"
import { getAllProjectRole } from "@/api/project/project"
import { getUser, initUserData } from "@/utils/user"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "DataTeam",
  components: {
    BaseButton,
    AddNewParticipantDialog,
    UpdateOwnerDialog,
    StaffPopover,
    StaffAvatar
  },
  props: {
    taskInfo: Object,
    permission: Object
  },
  data() {
    return {
      roles: []
    }
  },
  computed: {
    roleMap() {
      return this._.keyBy(this.roles, "id")
    },
    // 团队人员
    teamMembers() {
      if (!this.taskInfo.participants) return []
      let users =
        this.taskInfo.participants?.map(id => ({
          id,
          role: this.taskInfo.assignee === id ? "负责人" : "参与者",
          name: getUser(id)?.name,
          avatar: getUser(id)?.avatar,
          type: "user"
        })) || []
      let roles = this.taskInfo.participantRoles?.map(id => ({
        id,
        role: "参与者",
        name: this.roleMap[id]?.name,
        tip: this.roleMap[id]?.users.map(u => u.name).join(","),
        type: "role"
      }))
      return users.concat(roles)
    },
    // 是否有更换负责人权限
    has_TL_privilege() {
      return this.permission.CHANGE_ASSIGNEE
    },
    // 是否有编辑团队成员权限
    has_TM_privilege() {
      return this.permission.CHANGE_PARTICIPANT
    },
    hasPermission() {
      return this.has_TL_privilege || this.has_TM_privilege
    }
  },
  created() {
    getAllProjectRole(this.taskInfo.projectId).then(roles => (this.roles = roles || []))
    initUserData()
  },
  methods: {
    updateOwner({ ownerId, partFlag }) {
      updateOwner([this.taskInfo.id], ownerId, partFlag).then(() => {
        let participants = this.taskInfo.participants
        if (!partFlag) {
          participants.splice(
            participants.findIndex(item => item === this.taskInfo.assignee),
            1
          )
        }
        this.taskInfo.assignee = ownerId
        if (!participants.includes(ownerId)) {
          participants.push(ownerId)
        }
        this.$message.success("操作成功!")
        this.$emit("change", "owner")
      })
    },
    // 移除参与者
    removeMembers({ id, type }) {
      // 因为此处角色id和人员id不可能重复,所以暂时不必区分type
      let curUserIds = this.taskInfo.participants.filter(i => i != id)
      let curRoleIds = this.taskInfo.participantRoles.filter(i => i != id)
      this.updateParticipants(curUserIds, curRoleIds)
    },
    addParticipant(userIds, roleIds) {
      this.taskInfo.participants = Array.from(new Set(this.taskInfo.participants.concat(userIds)))
      this.taskInfo.participantRoles = Array.from(
        new Set(this.taskInfo.participantRoles.concat(roleIds))
      )
      this.updateParticipants(this.taskInfo.participants, this.taskInfo.participantRoles)
    },
    // 更新参与者
    updateParticipants(userIds, roleIds) {
      updateParticipants(this.taskInfo.id, userIds, roleIds).then(() => {
        this.taskInfo.participants = userIds
        this.taskInfo.participantRoles = roleIds
        this.$message.success("操作成功!")
        this.$emit("change", "participant")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.data-team {
  padding-right: 56px;
  padding-bottom: 60px;
  .operate-list {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 6px;
    .operate-item {
      margin-left: 10px;
    }
  }
  .name-cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-team {
    ::v-deep {
      th,
      td {
        padding: 0;
        box-sizing: border-box;
      }
      th {
        height: 41px;
        line-height: 41px;
        font-weight: normal;
      }
      td {
        height: 42px;
        line-height: 42px;
        font-size: 13px;
      }
    }
  }
}
.member-dlg {
  ::v-deep .el-dialog {
    .el-dialog__header {
      padding: 0 24px;
      height: 64px;
      border-bottom: 2px solid #f5f5f5;
      .dlg-title {
        line-height: 64px;
      }
    }
    .el-dialog__body {
      .input-list {
        padding: 14px 24px 0 24px;
        .input-item {
          margin-bottom: 14px;
          .input-label {
            margin-bottom: 5px;
          }
        }
        .el-input__inner {
          width: 320px;
          height: 36px;
        }
      }
      .tail-row {
        padding: 0 24px;
        height: 62px;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        border-top: 2px solid #f5f5f5;
        button {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
